import { type ComponentType, Suspense } from "react";

import { Spinner } from "@/components/spinner.tsx";

export function withSuspense<P extends object>(Component: ComponentType<P>): ComponentType<P> {
    return function SuspenseComponent(props: P) {
        return (
            <Suspense
                fallback={
                    <div
                        style={{
                            padding: 16,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "100vh",
                        }}
                    >
                        <Spinner />
                    </div>
                }
            >
                <Component {...props} />
            </Suspense>
        );
    };
}
